import React, { useEffect, useState } from "react";
import { Empty, Modal, Form, Input, Select, Button, message } from "antd";
import { useNavigate,useParams } from "react-router-dom";
import useJDStore from "../../store/jd.store";
import "./panel.scss";
import { UserAddOutlined } from "@ant-design/icons";


export default function Panels() {
    const isClickable = false;
    const navigate = useNavigate();
     const { value } = useParams();
    console.log("jdID", value   );
    
  
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState(new Set());
    const [form] = Form.useForm();
    const { createPanel,getJDPanel,panelList } = useJDStore();
    console.log("panel list",panelList);
    
    useEffect(() => {
        getJDPanel(value);
     
    }, []);
    const [tableData, setTableData] = useState([
        {
            name: "John Doe",
            email: "john.doe@example.com",
            contact_number: "555-0101",
            skill: "React",
            group: "Group A",
            available_time: "Full-time",
            day: ["Monday", "Wednesday", "Friday"],
            time_slot: ["9:00 AM - 10:00 AM", "2:00 PM - 3:00 PM"]
        },
    ]);

    const groups = ["Group_A", "Group_B", "Group_C", "Group_D", "Group_E"];
    const fixedHeaders = ["Name", "Email", "Contact", "Skill", "Group"];
    const MAX_MEMBERS_PER_GROUP = 3;

    const getGroupMemberCount = (group) => {
        return panelList.filter(item => item.Group === group).length;
    };

    const getAvailableGroups = () => {
        return groups.filter(group => getGroupMemberCount(group) < MAX_MEMBERS_PER_GROUP);
    };

    const handleAddPanel = () => {
        if (getAvailableGroups().length === 0) {
            message.error("All groups are full (3 members each)");
            return;
        }
        setIsModalOpen(true);
    };

    const handleModalSubmit = (values) => {
        createPanel(value, values);
        console.log("new panel", values);
        getJDPanel(value);
        setIsModalOpen(false);
        form.resetFields();
    };

    if (!panelList || panelList.length === 0) {
        return <Empty style={{ margin: "60px" }} description="No data available" />;
    }

    

    const handleCheckboxChange = (id) => {
        const newSelected = new Set(selectedRows);
        if (newSelected.has(id)) {
            newSelected.delete(id);
        } else {
            newSelected.add(id);
        }
        setSelectedRows(newSelected);
    };

    // ... rest of code

    return (
        <div className="panel-rtable-wrapper">
            <div className=" Panel-btn" style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button type="primary" icon={<UserAddOutlined />} onClick={handleAddPanel}>
                    Add Panel
                </Button>
            </div>

            <Modal
                title="Add New Panel"
                open={isModalOpen}
                onOk={() => form.submit()}
                onCancel={() => setIsModalOpen(false)}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleModalSubmit}
                >
                    <Form.Item
                        label="Name"
                        name="name"
                        rules={[{ required: true, message: "Please enter name" }]}
                    >
                        <Input placeholder="Enter name" />
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[{ required: true, type: "email", message: "Please enter valid email" }]}
                    >
                        <Input placeholder="Enter email" />
                    </Form.Item>
                    <Form.Item
                        label="Contact Number"
                        name="contact_number"
                        rules={[{ required: true, message: "Please enter contact number" }]}
                    >
                        <Input placeholder="Enter contact number" />
                    </Form.Item>
                    <Form.Item
                        label="Skill"
                        name="skill"
                        rules={[{ required: true, message: "Please enter skill" }]}
                    >
                        <Input placeholder="Enter skill" />
                    </Form.Item>
                    <Form.Item
                        label="Group"
                        name="group"
                        rules={[{ required: true, message: "Please select group" }]}
                    >
                        <Select placeholder="Select group">
                            {getAvailableGroups().map(group => (
                                <Select.Option key={group} value={group}>
                                    {group} ({getGroupMemberCount(group)}/3)
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Select Day"
                        name="day"
                        rules={[{ required: true, message: "Please select a day" }]}
                    >
                        <Select mode="multiple" placeholder="Select days" style={{ width: "100%" }}>
                            <Select.Option value="Monday">Monday</Select.Option>
                            <Select.Option value="Tuesday">Tuesday</Select.Option>
                            <Select.Option value="Wednesday">Wednesday</Select.Option>
                            <Select.Option value="Thursday">Thursday</Select.Option>
                            <Select.Option value="Friday">Friday</Select.Option>
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="Select Time Slot"
                        name="time_slot"
                        rules={[{ required: true, message: "Please select a time slot" }]}
                    >
                        <Select mode="multiple" placeholder="Select time slots" style={{ width: "100%" }}>
                            <Select.Option value="9:00 AM - 10:00 AM">9:00 AM - 10:00 AM</Select.Option>
                            <Select.Option value="10:00 AM - 11:00 AM">10:00 AM - 11:00 AM</Select.Option>
                            <Select.Option value="2:00 PM - 3:00 PM">2:00 PM - 3:00 PM</Select.Option>
                            <Select.Option value="3:00 PM - 4:00 PM">3:00 PM - 4:00 PM</Select.Option>
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>

            <div className="rtable-title-wrapper" style={{ gridTemplateColumns: `0.5fr repeat(${fixedHeaders.length + 2}, 1fr)` }}>
                <div className="rtable-title">✓</div>
                {fixedHeaders.map((title) => (
                    <div key={title} className="rtable-title">{title}</div>
                ))}
                <div className="rtable-title">📅 Day</div>
                <div className="rtable-title">⏰ Time Slot</div>
            </div>
            {panelList && Array.isArray(panelList) && panelList.map((table,index) => (
                <div key={index} className="rtable-info-wrapper" style={{ gridTemplateColumns: `0.5fr repeat(${fixedHeaders.length + 2}, 1fr)`, cursor: isClickable ? "pointer" : "default" }}>
                    <div className="rtable-info">
                        <input
                            type="checkbox"
                            checked={selectedRows.has(table.id)}
                            onChange={() => handleCheckboxChange(table.id)}
                        />
                    </div>
                    <div className="rtable-info">{table.name || "--"}</div>
                    <div className="rtable-info">{table.email || "--"}</div>
                    <div className="rtable-info">{table.contact_number || "--"}</div>
                    <div className="rtable-info">{table.skill || "--"}</div>
                    <div className="rtable-info">{table.group || "--"}</div>
                    <div className="rtable-info">
                        <Select
                            mode="multiple"
                            placeholder="Select days"
                            value={table.day || []}
                            style={{ width: "100%" }}
                            disabled={!selectedRows.has(table.id)}
                            onChange={(value) => {
                                const updatedData = [...tableData];
                                updatedData[tableData.indexOf(table)].day = value;
                                setTableData(updatedData);
                            }}
                        >
                            <Select.Option value="Monday">Monday</Select.Option>
                            <Select.Option value="Tuesday">Tuesday</Select.Option>
                            <Select.Option value="Wednesday">Wednesday</Select.Option>
                            <Select.Option value="Thursday">Thursday</Select.Option>
                            <Select.Option value="Friday">Friday</Select.Option>
                        </Select>
                    </div>
                    <div className="rtable-info">
                        <Select
                            mode="multiple"
                            placeholder="Select time slots"
                            value={table.time_slot || []}
                            style={{ width: "100%" }}
                            disabled={!selectedRows.has(table.id)}
                            onChange={(value) => {
                                const updatedData = [...tableData];
                                updatedData[tableData.indexOf(table)].time_slot = value;
                                setTableData(updatedData);
                            }}
                        >
                            <Select.Option value="9:00 AM - 10:00 AM">9:00 AM - 10:00 AM</Select.Option>
                            <Select.Option value="10:00 AM - 11:00 AM">10:00 AM - 11:00 AM</Select.Option>
                            <Select.Option value="2:00 PM - 3:00 PM">2:00 PM - 3:00 PM</Select.Option>
                            <Select.Option value="3:00 PM - 4:00 PM">3:00 PM - 4:00 PM</Select.Option>
                        </Select>
                    </div>
                </div>
            ))}
        </div>
    );
}
